import React from 'react';
import { connect } from 'react-redux'
import { Utils } from '../../utilSMB/utils';

class ProductDetailColor extends React.PureComponent {
    render(){
            let colorList=[];
            let selectedColor='';
            let styleColor=[];
            let lytColor=[];
            let darkColor=[];
            let textColor=''
            let color         
            let prodcolor         
            this.props.itemValue.map((itemValue, index) => {
                if(itemValue.color){
                prodcolor=itemValue.color.replace(/\s/g, '')
                }
                else{
                 prodcolor=itemValue.color
                }
                if(this.props.itemValue.length===1){
                    if (Utils.isNotNull(itemValue.color)) {
                         color=itemValue.color
                        lytColor=['Chalk','Charcoal','Lilac','Slate','White']
                        darkColor=['Black','Blue','Gray','Grey','Silver']
                        lytColor.map((colorLyt,index)=>{
                            if(colorLyt===color){
                                textColor="text-black"
                            }
                            return "";
                        })
                        darkColor.map((colorDark,index)=>{
                            if(colorDark===color){
                                textColor="text-white"
                            }
                            return "";
                        })
                    selectedColor=("bg-sku830084-sku830084 active active-check mediumcpicker bg-" +prodcolor.toLowerCase()+ " "+textColor)
                    styleColor=itemValue.color;
                }}
                else if(this.props.itemValue.length>1){
                    if (Utils.isNotNull(itemValue.color)) {
                         color=itemValue.color
                        lytColor=['Chalk','Charcoal','Lilac','Slate','White']
                        darkColor=['Black','Blue','Gray','Grey','Silver']
                        lytColor.map((colorLyt,index)=>{
                            if(colorLyt===color){
                                textColor="text-black"
                            }
                            return "";
                        })
                        darkColor.map((colorDark,index)=>{
                            if(colorDark===color){
                                textColor="text-white"
                            }
                            return "";
                        })
                    selectedColor=(this.props.selectedValue.productId===itemValue.productId ? ("bg-sku830084-sku830084 active active-check mediumcpicker bg-" +prodcolor.toLowerCase()+ " "+textColor) :("bg-sku830084-sku830084 mediumcpicker bg-" +prodcolor.toLowerCase()+ " "+textColor))  
                    styleColor=itemValue.color;
                 }}
                 if (Utils.isNotNull(selectedColor) && selectedColor!=="") {
                colorList.push(
                    <span>
                       <li className={selectedColor} id="prod670040_sku830084_sku830084" style={{ backgroundColor : styleColor}} title={styleColor} onClick={(e) => { this.props.colorSelectionValue(itemValue.productId)}}></li> &nbsp;&nbsp;&nbsp;
                    </span>
                 )}
                 return "";
            }) 
        return (
            <React.Fragment>
                <ul className="no-bullet" data-product-color="">
                {colorList}
                </ul>
            </React.Fragment>
        );
    }
}

export default (connect()(ProductDetailColor));
